
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationBuildingserviceEntryDto } from '../models/work-calculation-buildingservice-entry-dto';

export function getUpdateCalculationBuildingserviceEntriesDtoFormGroup() {
return new FormGroup({
    entries: new FormControl<WorkCalculationBuildingserviceEntryDto[]>([]),
})
;
}
      